export default __webpack_public_path__ + "static/media/message.87b82802.png";